const getStreamContent = (stream) => stream?.content || stream || null;

export const RETAINED_UPLOADED_VIDEO_ELEMENT_ID = 'stream-video-retained';
export const ROTATED_UPLOADED_VIDEO_COMPOSITOR_OPACITY = '0.999';

export const shouldCompositeUploadedVideoForRotation = () => {
  if (typeof window === 'undefined' || typeof document === 'undefined') return false;
  const config = window.trillboardsScreenConfig;
  return Boolean(config?.rotationActive === true)
    || Boolean(document.body?.classList?.contains('trillboards-rotation-active'));
};

export const getVideoOpacity = () =>
  shouldCompositeUploadedVideoForRotation()
    ? ROTATED_UPLOADED_VIDEO_COMPOSITOR_OPACITY
    : '1';

export const isUploadedVideoStream = (stream) => {
  const content = getStreamContent(stream);
  return String(content?.stream_type || content?.streamType || '').toLowerCase() === 'uploaded';
};

export const shouldPreserveUploadedVideoElement = (currentStream, nextStream) =>
  isUploadedVideoStream(currentStream) && Boolean(getStreamContent(nextStream));

export const resolveUploadedVideoElement = (existingVideo, createVideoElement) => {
  if (existingVideo?.tagName === 'VIDEO') {
    return existingVideo;
  }
  return createVideoElement();
};

export const hideUploadedVideoForSourceChange = (videoElement) => {
  if (!videoElement) return null;
  videoElement.muted = true;
  videoElement.volume = 0;
  videoElement.style.transition = 'none';
  videoElement.style.opacity = '0';
  videoElement.dataset.playbackActive = 'false';
  // Park the element under a separate ID while non-video plugins are active.
  // Their defensive cleanup only targets the active video ID, so the native
  // surface survives slideshow/iframe gaps without interfering with them.
  videoElement.id = RETAINED_UPLOADED_VIDEO_ELEMENT_ID;
  return videoElement;
};
